import { useTranslation } from 'react-i18next'

export default function ValueBand() {
  const { t } = useTranslation()

  const cards = [
    { num: t('shop.valueBand.card1Num'), title: t('shop.valueBand.card1Title'), tag: t('shop.valueBand.card1Tag'), body: t('shop.valueBand.card1Body') },
    { num: t('shop.valueBand.card2Num'), title: t('shop.valueBand.card2Title'), tag: t('shop.valueBand.card2Tag'), body: t('shop.valueBand.card2Body') },
    { num: t('shop.valueBand.card3Num'), title: t('shop.valueBand.card3Title'), tag: t('shop.valueBand.card3Tag'), body: t('shop.valueBand.card3Body') },
  ]

  return (
    <section className="py-20 border-t border-neutral-100 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-[11px] font-bold tracking-[0.18em] uppercase text-primary mb-3">
          {t('shop.valueBand.eyebrow')}
        </p>
        <h2 className="text-[28px] font-bold text-gcg-text tracking-[-0.015em] leading-snug mb-10 max-w-[560px]">
          {t('shop.valueBand.heading')}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {cards.map(card => (
            <div
              key={card.num}
              className="bg-white border border-neutral-200 border-l-[3px] border-l-primary p-7"
            >
              <p className="text-[11px] font-bold tracking-[0.18em] uppercase text-primary mb-3">
                {card.num}
              </p>
              <h3 className="text-base font-bold text-gcg-text mb-1">{card.title}</h3>
              <p className="text-sm font-semibold text-neutral-700 mb-2">{card.tag}</p>
              <p className="text-sm text-neutral-600 leading-relaxed">{card.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
